/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Callback_Signing_InInputs */

const en_auth_callback_signing_in = /** @type {(inputs: Auth_Callback_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing you in…`)
};

const ar_auth_callback_signing_in = /** @type {(inputs: Auth_Callback_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تسجيل دخولك…`)
};

/**
* | output |
* | --- |
* | "Signing you in…" |
*
* @param {Auth_Callback_Signing_InInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const auth_callback_signing_in = /** @type {((inputs?: Auth_Callback_Signing_InInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Callback_Signing_InInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_callback_signing_in(inputs)
	return ar_auth_callback_signing_in(inputs)
});